export const GET_CONNECTORS = 'GET_CONNECTORS';
export const LOAD_CONNECTORS = 'LOAD_CONNECTORS';
export const CONNECT_TO_TYPE = 'CONNECT_TO_TYPE';
export const DISCONNECT_FROM_TYPE = 'DISCONNECT_FROM_TYPE';
